import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { AgGridReact } from "ag-grid-react"; // AG Grid Component
import { VariantsAPI, WeighmentSitesAPI } from "api";
import CardDropdown from "components/common/CardDropdown";
import IconButton from "components/common/IconButton";
import TableHeaderDropdown from "components/common/TableHeaderDropdown";
import { settings } from "config";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Card, Dropdown, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { MdOutlineModeEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { CONSTANT_ROUTES } from "routes";
import PageTitle from "utils/PageTitle";
import {
  resetColumnState,
  restoreColumnState,
  saveColumnState,
} from "utils/tablesUtils";
import "./styles.css";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";
import { MarqueeMessagesAPI } from "../../../api";

// export default function MarqueeMessageTableTest({ onSelect }) {
//   let isDarkBool = localStorage.getItem("isDark") === true;
//   let isDarkTheme = localStorage.getItem("theme") === "dark";
//   let auto = localStorage.getItem("theme") === "auto";
//   const navigate = useNavigate();
//   const columnApiRef = useRef();
//   const gridRef = useRef();

//   const [colDefs] = useState([
//     // { field: "", filter: false, headerName: "Select" },

//     // {
//     //   field: "type",
//     //   headerName: "Type",

//     //   hide: false,
//     // },
//     {
//       field: "message",
//       headerName: "Message",
//       hide: false,
//       flex: 2,
//       cellStyle: {
//         whiteSpace: "nowrap",
//         textOverflow: "ellipsis",
//         overflow: "hidden",
//       },
//     },
//     {
//       field: "url",
//       headerName: "URL",
//       hide: false,
//       flex: 2,
//       cellStyle: {
//         whiteSpace: "nowrap",
//         textOverflow: "ellipsis",
//         overflow: "hidden",
//       },
//     },
//     {
//       field: "order",
//       headerName: "Display Order",
//       hide: false,
//       flex: 1.75,
//       filter: false,
//       headerClass: "center-header",
//       cellStyle: {
//         display: "flex",
//         // paddingRight: "30px",
//         justifyContent: "center",
//       },
//     },

//     {
//       field: "status",
//       headerName: "Active",
//       hide: false,
//       flex: 1.5,
//       filter: false,
//       cellStyle: {
//         display: "flex",
//         // paddingRight: "30px",
//         justifyContent: "center",
//       },
//       headerClass: "center-header",
//       cellRenderer: (p) => (
//         <Form.Check
//           type="checkbox"
//           id="statusSwitch"
//           style={{ padding: "10px 0px" }}
//           checked={p?.data.status}
//         />
//       ),
//     },
//     {
//       headerName: "Action",
//       field: "action",
//       flex: 1.5,
//       filter: false,
//       cellStyle: {
//         display: "flex",
//         // paddingRight: "30px",
//         justifyContent: "center",
//       },
//       headerClass: "center-header",
//       cellRenderer: (p) => (
//         <CardDropdown>
//           <div className="py-2">
//             <Dropdown.Item
//               // as={Link}
//               onClick={() =>
//                 // navigate(`/libraries/categories/add-new-category/?id=${p.data.id}`)
//                 // () =>
//                 handleRowClick(p.data)
//               }
//               // href="/products/add-product"
//               className="d-flex align-items-center gap-2 py-0"
//             >
//               <MdOutlineModeEdit />
//               Edit
//             </Dropdown.Item>
//             {/* <Dropdown.Item
//               // onClick={() => handleDelete()}
//               className="d-flex align-items-center gap-2 py-0"
//             >
//               <MdDeleteOutline />
//               Delete
//             </Dropdown.Item> */}
//           </div>
//         </CardDropdown>
//       ),
//     },
//   ]);

//   // const handleRowClick = (data) => {
//   //   if (data) {
//   //     navigate(`${CONSTANT_ROUTES.MARQUEE_MESSAGES_ADD}`, { state: data });
//   //   }
//   // };

//   const handleRowClick = (data) => {
//     if (onSelect) onSelect(data);
//   };

//   const defaultColDef = {
//     sortable: true,
//     filter: true,
//     // floatingFilter: true,
//     // flex: 1,
//     // rowDrag: true,
//   };

//   //   ===============Custom Api Call start================

//   let gridApi;
//   let columnApi;

//   const onGridReady = useCallback(
//     (e) => {
//       gridApi = e.api;
//       columnApi = e.columnApi;
//       restoreState();
//       MarqueeMessagesAPI.get().then((res) => {
//         e.api.applyTransaction({ add: res?.data?.data });
//       });
//     },
//     [window]
//   );

//   const saveState = useCallback(() => {
//     saveColumnState("marquess-message-table", columnApiRef);
//   }, []);

//   const restoreState = useCallback(() => {
//     restoreColumnState("marquess-message-table", columnApiRef);
//   }, []);

//   const resetState = useCallback(() => {
//     resetColumnState("marquess-message-table", columnApiRef);
//   }, []);

//   const onFilterTextBoxChanged = useCallback(() => {
//     columnApiRef.current.api.setGridOption(
//       "quickFilterText",
//       document.getElementById("filter-text-box").value
//     );
//   }, []);

//   return (
//     <div>
//       {/* <div className="py-2">
//         <BreadCrumb />
//       </div> */}

//       <PageTitle name="Shopenze | Marquee Messages" />

//       <div
//         className={`${isDarkBool || isDarkTheme || auto
//           ? "ag-theme-quartz-dark"
//           : "ag-theme-quartz"
//           } rounded-0`} // applying the grid theme
//       // style={{ height: "100vh" }} // the grid will fill the size of the parent container
//       >
//         <Card style={{ height: `calc(100vh - 4rem)`, overflow: "auto" }}>
//           <Card.Header className="d-flex justify-content-between align-items-center">
//             <BreadCrumbTable title="Shopenze" subTitle="Marquee Messages" />
//             {/* <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">
//               {" "}
//               Libraries | Weighment Sites
//             </h5> */}
//             <div className="d-flex align-items-center gap-2">
//               <Form className="position-relative">
//                 <FontAwesomeIcon
//                   icon="search"
//                   className="position-absolute text-400 search-box-icon"
//                   style={{
//                     left: "10px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                   }}
//                 />
//                 <Form.Control
//                   type="search"
//                   placeholder="Search..."
//                   style={{
//                     paddingLeft: "30px",
//                   }}
//                   aria-label="Search"
//                   id="filter-text-box"
//                   className="rounded-pill search-input"
//                   onInput={onFilterTextBoxChanged}
//                 />
//               </Form>
//               <OverlayTrigger
//                 overlay={
//                   <Tooltip
//                     style={{ position: "fixed" }}
//                     id="overlay-trigger-example"
//                   >
//                     New
//                   </Tooltip>
//                 }
//               >
//                 <IconButton
//                   variant="falcon-default"
//                   size="sm"
//                   icon="plus"
//                   transform="shrink-3"
//                   onClick={() => navigate(CONSTANT_ROUTES.MARQUEE_MESSAGES_ADD)}
//                 >
//                   <span className="d-none d-sm-inline-block ms-1">New</span>
//                 </IconButton>
//               </OverlayTrigger>
//               <TableHeaderDropdown>
//                 <div className="py-2">
//                   <Dropdown.Item
//                     onClick={saveState}
//                     className="d-flex align-items-center gap-2 py-2"
//                   >
//                     Save State
//                   </Dropdown.Item>
//                   <Dropdown.Item
//                     onClick={restoreState}
//                     className="d-flex align-items-center gap-2 py-2"
//                   >
//                     Restore State
//                   </Dropdown.Item>
//                   <Dropdown.Item
//                     onClick={resetState}
//                     className="d-flex align-items-center gap-2 py-2"
//                   >
//                     Reset State
//                   </Dropdown.Item>
//                 </div>
//               </TableHeaderDropdown>
//             </div>
//           </Card.Header>

//           <Card.Body className="p-0">
//             <AgGridReact
//               // rowData={rowData}
//               ref={columnApiRef}
//               onGridReady={onGridReady}
//               pagination
//               paginationPageSize={settings.paginationSize}
//               columnDefs={colDefs}
//               defaultColDef={defaultColDef}
//               // onRowDoubleClicked={(params) => handleRowClick(params.data)}
//               onRowDoubleClicked={(params) => onSelect(params.data)}
//               overlayNoRowsTemplate="Nothing found - Looks empty over here"
//             />
//           </Card.Body>
//         </Card>
//       </div>
//     </div>
//   );
// }

export default function MarqueeMessageTableTest({ onSelect, refresh, onAddNew }) {
  let isDarkBool = localStorage.getItem("isDark") === true;
  let isDarkTheme = localStorage.getItem("theme") === "dark";
  let auto = localStorage.getItem("theme") === "auto";

  const columnApiRef = useRef();
  const gridRef = useRef();

  const [colDefs] = useState([
    {
      field: "message",
      headerName: "Message",
      flex: 2,
      cellStyle: {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
      },
    },
    {
      field: "url",
      headerName: "URL",
      flex: 2,
      cellStyle: {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
      },
    },
    {
      field: "order",
      headerName: "Display Order",
      flex: 1.75,
      filter: false,
      headerClass: "center-header",
      cellStyle: { display: "flex", justifyContent: "center" },
    },
    {
      field: "status",
      headerName: "Active",
      flex: 1.5,
      filter: false,
      headerClass: "center-header",
      cellRenderer: (p) => (
        <Form.Check
          type="checkbox"
          checked={p.data.status}
          style={{ padding: "10px 0" }}
        />
      ),
      cellStyle: { display: "flex", justifyContent: "center" },
    },
    {
      headerName: "Action",
      field: "action",
      flex: 1.5,
      filter: false,
      headerClass: "center-header",
      cellStyle: { display: "flex", justifyContent: "center" },
      cellRenderer: (p) => (
        <CardDropdown>
          <div className="py-2">
            <Dropdown.Item
              className="d-flex align-items-center gap-2 py-0"
              onClick={() => onSelect(p.data)}
            >
              <MdOutlineModeEdit />
              Edit
            </Dropdown.Item>
          </div>
        </CardDropdown>
      ),
    },
  ]);

  const defaultColDef = {
    sortable: true,
    filter: true,
  };

  // ------------------------ FETCH FUNCTION ------------------------
  const loadRows = useCallback(
    async (api) => {
      try {
        const res = await MarqueeMessagesAPI.get();
        api.setRowData(res?.data?.data || []);
      } catch (e) {
        console.log("Fetch error:", e);
      }
    },
    []
  );

  // ------------------------ GRID READY ------------------------
  const onGridReady = useCallback(
    (params) => {
      gridRef.current = params.api;
      loadRows(params.api);
    },
    [loadRows]
  );


  const saveState = useCallback(() => {
    saveColumnState("marquess-message-table", columnApiRef);
  }, []);

  const restoreState = useCallback(() => {
    restoreColumnState("marquess-message-table", columnApiRef);
  }, []);

  const resetState = useCallback(() => {
    resetColumnState("marquess-message-table", columnApiRef);
  }, []);

  const onFilterTextBoxChanged = useCallback(() => {
    columnApiRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);

  // ------------------------ REFETCH WHEN PARENT ASKS ------------------------
  useEffect(() => {
    if (gridRef.current) {
      loadRows(gridRef.current);
    }
  }, [refresh, loadRows]);

  return (
    <div className={`${isDarkBool || isDarkTheme || auto
      ? "ag-theme-quartz-dark"
      : "ag-theme-quartz"}`}>
      <Card style={{ height: `calc(100vh - 4rem)` }}>
        <Card.Header className="d-flex justify-content-between align-items-center px-1 gap-2">
          <BreadCrumbTable base={false} title="Marquee Messages" />

          <div className="d-flex align-items-center gap-2">
            <Form className="position-relative">
              <FontAwesomeIcon
                icon="search"
                className="position-absolute text-400 search-box-icon"
                style={{
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />
              <Form.Control
                type="search"
                placeholder="Search..."
                style={{
                  paddingLeft: "30px",
                }}
                aria-label="Search"
                id="filter-text-box"
                className="rounded-pill search-input"
                onInput={onFilterTextBoxChanged}
              />
            </Form>
            <OverlayTrigger
              overlay={
                <Tooltip
                  style={{ position: "fixed" }}
                  id="overlay-trigger-example"
                >
                  New
                </Tooltip>
              }
            >
              <Button
                variant="falcon-default"
                size="sm"
                icon="plus"
                transform="shrink-3"
                style={{ width: 'fit-content' }}
                onClick={onAddNew}
              // onClick={() => navigate(CONSTANT_ROUTES.MARQUEE_MESSAGES_ADD)}
              >
                <span className="d-none d-sm-inline-block ms-1">New</span>
              </Button>
            </OverlayTrigger>
            {/* <TableHeaderDropdown>
              <div className="py-2">
                <Dropdown.Item
                  onClick={saveState}
                  className="d-flex align-items-center gap-2 py-2"
                >
                  Save State
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={restoreState}
                  className="d-flex align-items-center gap-2 py-2"
                >
                  Restore State
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={resetState}
                  className="d-flex align-items-center gap-2 py-2"
                >
                  Reset State
                </Dropdown.Item>
              </div>
            </TableHeaderDropdown> */}
          </div>
        </Card.Header>

        <Card.Body className="p-0">
          <AgGridReact
            ref={columnApiRef}
            onGridReady={onGridReady}
            rowSelection="single"
            columnDefs={colDefs}
            defaultColDef={defaultColDef}
            pagination
            paginationPageSize={10}
            onRowDoubleClicked={(params) => onSelect(params.data)}
            overlayNoRowsTemplate="Nothing found - Looks empty over here"
          />
        </Card.Body>
      </Card>
    </div>
  );
}
